module.exports = __webpack_public_path__ + "img/nantun-photo.c2373507.png";